export const GenderData = [
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
];

export const schemeTypeData = [
  {
    label: "Public",
    value: "PUBLIC",
  },
  {
    label: "Private",
    value: "PRIVATE",
  },
  {
    label: "Community",
    value: "COMMUNITY",
  },
  {
    label: "Asal",
    value: "ASAL",
  },
];
export const dataTypeData = [
  {
    label: "Production Data",
    value: "PRODUCTION_DATA",
  },
  {
    label: "Farm Input",
    value: "FARM_INPUT",
  }, 
];


export const agencyTypeData = [
  {
    label: "NIA",
    value: "NIA",
  },
  {
    label: "NWHSA",
    value: "NWHSA",
  },
];
export const schemeSizeData = [
  {
    label: "Small",
    value: "Small",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "Large",
    value: "Large",
  },
];
 
export const projStatusData = [
  {
    label: "PLANNED",
    value: "PLANNED",
  },
  {
    label: "ONGOING",
    value: "ONGOING",
  },
  {
    label: "COMPLETED",
    value: "COMPLETED",
  },
];
  
export const compStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "COMPLETED",
    value: "COMPLETED",
  }, 
  {
    label: "STALLED",
    value: "STALLED",
  }, 
];
 
export const paymentStatusData = [
  {
    label: "PENDING PAYMENT",
    value: "PENDING_PAYMENT",
  },
  {
    label: "PAID",
    value: "PAID",
  }, 
];

export const issueStatusData = [
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "COMPLETED",
    value: "COMPLETED",
  }, 
];

export const damStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "SILTED",
    value: "SILTED",
  }, 
  {
    label: "DECOMMISSIONED",
    value: "DECOMMISSIONED",
  }, 
];

export const boreholeStatusData = [
  {
    label: "COLLAPSED",
    value: "COLLAPSED",
  },
  {
    label: "YIELDING",
    value: "YIELDING",
  }, 
  {
    label: "DRY",
    value: "DRY",
  }, 
  {
    label: "CAPPED",
    value: "CAPPED",
  }, 
];

export const wtrSupplyStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "INACTIVE",
    value: "INACTIVE",
  }, 
   
];

export const FldControlStatusData = [
  {
    label: "FUNCTIONAL",
    value: "FUNCTIONAL",
  },
  {
    label: "DAMAGED",
    value: "DAMAGED",
  }, 
  {
    label: "BREACHED",
    value: "BREACHED",
  }, 
  {
    label: "DRY",
    value: "DRY",
  }, 
  {
    label: "OVERFLOWING",
    value: "OVERFLOWING",
  },  
];
export const rvrTrainingStatusData = [
  {
    label: "COMPLETED",
    value: "COMPLETED",
  },
  {
    label: "DAMAGED",
    value: "DAMAGED",
  }, 
  {
    label: "BREACHED",
    value: "BREACHED",
  }, 
  {
    label: "DRY",
    value: "DRY",
  }, 
  {
    label: "OVERFLOWING",
    value: "OVERFLOWING",
  },  
];

export const plannedProjStatusData = [
  {
    label: "PROPOSAL",
    value: "PROPOSAL",
  },
  {
    label: "CONCEPT",
    value: "CONCEPT",
  }, 
  
];
export const schReclStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];

export const cropBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];
export const grassBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];

export const negarimBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];
export const treeBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];

export const panStatusData = [
  {
    label: "OPERATIONAL",
    value: "OPERATIONAL",
  },
  {
    label: "SILTED",
    value: "SILTED",
  },  
  {
    label: "DRY",
    value: "DRY",
  },  
];

export const wtrHarvesters=[
  {
    label: "Boreholes",
    value: "Boreholes",
  },
  {
    label: "Dams",
    value: "Dams",
  },
  {
    label: "Water Pans",
    value: "Water_Pans",
  }, 
]
export const reclamations=[
  {
    label: "Negarims",
    value: "Negarims",
  },
  {
    label: "Schemes",
    value: "Schemes",
  },
  {
    label: "Grass Bands",
    value: "Grass_Bands",
  },
  {
    label: "Crop Bands",
    value: "Crop_Bands",
  },

  {
    label: "Trees Catchment",
    value: "Trees_Catchment",
  }, 
]


export const projMemberType=[
  {
    label: "MANAGER",
    value: "MANAGER",
  },
  {
    label: "RESIDENTIAL_ENGINEER",
    value: "RESIDENTIAL_ENGINEER",
  },
  {
    label: "ASSISTANT_RESIDENTIAL_ENGINEER",
    value: "ASSISTANT_RESIDENTIAL_ENGINEER",
  }, 
  {
    label: "IMPLEMENTATION_COMMITTEE",
    value: "IMPLEMENTATION_COMMITTEE",
  },
  {
    label: "CONTRACTOR_REPRESENTATIVE",
    value: "CONTRACTOR_REPRESENTATIVE",
  }, 
  {
    label: "COMMUNITY_REPRESENTATIVE",
    value: "COMMUNITY_REPRESENTATIVE",
  },
  {
    label: "CLIENT",
    value: "CLIENT",
  },
]

export const schStatusData=[
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  }, 
   {
    label: "UNDER CONSTRUCTION",
    value: "UNDER_CONSTRUCTION",
  },
   {
    label: "STALLED",
    value: "STALLED",
  },
]
export const mtrTypeData=[
  {
    label: "MASTER",
    value: "MASTER",
  },
  {
    label: "INDIVIDUAL",
    value: "INDIVIDUAL",
  }, 
  {
    label: "BOTH",
    value: "BOTH",
  }, 
  {
    label: "NONE",
    value: "NONE",
  }, 
]

export const dynamicTypeData=[
  {
    label: "PDF",
    value: "PDF",
  },
  {
    label: "CSV",
    value: "CSV",
  }, 
 {
    label: "XLSX",
    value: "XLSX",
  }, 
]

export const schemeSetupTypeData=[
  {
    label: "TEXT",
    value: "TEXT",
  }, 
  {
    label: "NUMBER",
    value: "NUMBER",
  }, 
  {
    label: "RADIO",
    value: "RADIO",
  }, 
]

export const schemeSetupCateData=[
  {
    label: "Metrics",
    value: "Metrics",
  }, 
  {
    label: "performance",
    value: "performance",
  },  
]

export const tierData = [
  {
    label: "Tier 1 Expansion",
    value: "Tier 1 Expansion",
  },
  {
    label: "Tier 2 Expansion",
    value: "Tier 2 Expansion",
  }, 
];